/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext } from 'react';
import { Checkbox, FormControlLabel, FormHelperText } from '@material-ui/core';

import { FormContext } from './FormContext';
import { useFormField, type IFormFieldProps } from './useFormField';

export const FormCheckbox: React.FC<IFormFieldProps<boolean>> = (props) => {
    const { name, validators, title, helperText, value, ...rest } = props;

    const { handleChange, formValue } = useFormField<boolean>(props);

    const context = useContext(FormContext);

    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox
                        {...rest}
                        onChange={handleChange(name, validators)}
                    />
                }
                checked={!!formValue}
                label={title}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </>
    );
};
